import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link, Redirect } from "react-router-dom";
import logo from "../../../../assets/img/logo.png";

class HomeContainer extends Component {
  render() {
    const { from } = this.props.location.state || { from: "/main" };
    const { isAuthenticated } = this.props;

    if (isAuthenticated) {
      return <Redirect to={from} />;
    }

    return (
      <div className="index-wrapper">
        <div className="table-wrapper">
          <div className="table-row">
            <div className="table-cell">
              <div className="inner-wrapper">
                <div className="bg-wrapper">
                  <div className="left">
                    <div className="header mt-3">
                      <Link to="/">
                        <img src={logo} alt="" />
                      </Link>
                      <h2 className="font-weight-thin">
                        Welcome to the MARINA Integrated Seafarers Management
                        Online (MISMO) System
                      </h2>
                    </div>
                  </div>
                  <div className="right">
                    <div className="position p-4">
                      <div className="form-wrapper">
                        <h3 className="mb-4 font-weight-thin">
                          You can now set an appointment with MARINA.
                        </h3>
                        <div className="mb-2">
                          {/* <p className="mb-2">
                            The MARINA enforces strict rules for personal
                            appearance.
                          </p> */}
                          <p>
                            In the light of safety and precautionary health
                            measures, the MARINA shall conduct a full online
                            evaluation of applications for issuance of STCW
                            Certificates. The personal presence of the applicant
                            will only be required during the scheduled release
                            of certificates and theoretical assessment permit.
                            {/* All seafarers with appointment schedules, must appear physically at the
                            MARINA on the specified date and time for image capturing. */}
                          </p>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              <small className="text-muted">
                                Don’t have an account?
                              </small>
                            </p>
                            <Link
                              to="/register-type"
                              className="btn btn-primary btn-block"
                            >
                              Sign Up
                            </Link>
                            <Link
                              to="/signin"
                              className="btn btn-danger btn-block"
                            >
                              Sign In
                            </Link>
                            <div className="or-span">
                              <span>OR</span>
                            </div>
                            <Link
                              to="/verify-id-certificate"
                              className="btn btn-warning btn-block"
                            >
                              Verify SIRB/ID/Cert
                            </Link>

                            <Link
                              to="/verify-qr-code"
                              className="btn btn-info btn-block"
                            >
                              Verify Cert via QR Code
                            </Link>

                            <Link
                              to="/examination-schedules"
                              className="btn btn-success btn-block"
                            >
                              Exam Schedules
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return (state, route) => {
    const { auth } = state;

    return {
      isAuthenticated: auth.get("isAuthenticated")
    };
  };
};

export default withRouter(connect(mapStateToProps)(HomeContainer));
